import { Skeleton } from 'src/shared/components/ui/miscellaneous/skeleton'

const TransactionVolumeCardSkeleton = () => {
  return (
    <div className="flex flex-col gap-3">
      <div className="grid flex-1 grid-cols-1 grid-rows-2 gap-6 rounded-lg border border-border bg-accent px-6 py-4 sm:grid-cols-2 sm:grid-rows-1 sm:gap-1">
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-8 w-32" />
        </div>
        <div className="flex flex-col gap-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-8 w-16" />
        </div>
      </div>
    </div>
  )
}

export default TransactionVolumeCardSkeleton
